import { render, staticRenderFns } from "./ItemListView.vue?vue&type=template&id=653972ef&scoped=true"
import script from "./ItemListView.vue?vue&type=script&lang=js"
export * from "./ItemListView.vue?vue&type=script&lang=js"
import style0 from "./ItemListView.vue?vue&type=style&index=0&id=653972ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653972ef",
  null
  
)

export default component.exports